import { Component, Input, OnInit } from '@angular/core';
import { MutasiAntarCounterService } from '../../pages/mutasi-antar-counter/mutasi-antar-counter.service';
import { UtilService } from '../../service/util.service';
import { ModalController } from '@ionic/angular';
import { count } from 'rxjs/operators';

@Component({
  selector: 'app-find-stock',
  templateUrl: './find-stock.component.html',
  styleUrls: ['./find-stock.component.scss'],
})
export class FindStockComponent implements OnInit {
  counters:any;
  stockData:any[];

  @Input() productList: any[];
  @Input() branchId:any;
  @Input() token: any;
  @Input() counterIdOrigin: any;
  @Input() warehouseType:any;
  counterList:any;
  selectedCounter:number=0;
  sortedCounterList: any[] = [];
  constructor(
    private mutasiAntarCounterService:MutasiAntarCounterService,
    private utilService:UtilService,
    private modalController:ModalController

  ) { }

  ngOnInit() {
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      let options = {
        "token": this.token,
        "branch_id": this.branchId,
        "product_list":this.productList,
        "counter_id_origin":this.counterIdOrigin,
        "warehouse_type_id":this.warehouseType
      };
      this.mutasiAntarCounterService.getStockForMutation(options).subscribe((response) => {
        this.utilService.loadingDismiss();
        this.stockData = response.results.data;
        const counters: any = {};
        const products: any = {};
        // ambil semua counter unik
        this.stockData.forEach((item: any) => {
          counters[item.counter_id] = item.counter_name;
        });
        // loop SEMUA produk (bukan dari stockData)
        this.productList.forEach((prod: any) => {
          products[prod.product_id] = {
            product_id: prod.product_id,
            product_name: prod.product_name,
            qty: prod.qty,
            counters: {}
          };
          // isi semua counter dengan default 0
          Object.keys(counters).forEach(counterId => {
            products[prod.product_id].counters[counterId] = 0;
          });
        });
        // overwrite dengan data asli dari API
        this.stockData.forEach((item: any) => {
          if (products[item.product_id]) {
            products[item.product_id].counters[item.counter_id] = parseInt(item.stock_month);
          }
        });
        // set ke state
        this.counterList = Object.keys(counters).map(id => ({
          id,
          name: counters[id]
        }));
        this.productList = Object.values(products);
        this.sortedCounterList = this.counterList.slice().sort((a: any, b: any) => {
            const aValid = this.isCounterAllStockPositive(a.id);
            const bValid = this.isCounterAllStockPositive(b.id);

            // 1. Yang fully valid dulu
            if (aValid !== bValid) {
              return (bValid ? 1 : 0) - (aValid ? 1 : 0);
            }

            // 2. Kalau sama-sama tidak valid → pakai fulfillment score
            const aScore = this.getFulfillmentScore(a.id);
            const bScore = this.getFulfillmentScore(b.id);

            return bScore - aScore;
          });
      }, (err) => {
        this.utilService.loadingDismiss();
      });
    });
  }
  
  async dismissModal() {
    await this.modalController.dismiss(this.selectedCounter);
  }
  formatCounterName(name: string) {
    return name.replace(/ /g, '<br>');
  }
  pilihCounter(id:number){
    this.selectedCounter = id;
    this.dismissModal();
  }
  // counterId: string atau number
  isCounterAllStockPositive(counterId: any): boolean {
    return this.productList.every((product: any) => {
      let check = (parseInt(product.counters[counterId]) || 0) >= parseInt(product.qty);
      return check;
    });
  }
  getFulfillmentScore(counterId: any): number {
    return this.productList.reduce((score: number, product: any) => {
      const stock = parseInt(product.counters[counterId]) || 0;
      const qty = parseInt(product.qty) || 0;
      // ambil yang bisa dipenuhi dari product ini
      return score + Math.min(stock, qty);
    }, 0);
  }
}
